/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-21 14:47:46
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-09-22 16:45:43
 * @FilePath: \pit-bimwin-react-ui\src\components\PitModule\sectioning.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  FC,
  // CSSProperties,
  // memo,
  // useCallback,
  // useRef,
  // useEffect,
} from 'react';
interface PitBimwinSwitchCheckBoxProps {
  value: boolean;
  onChange(val: boolean): void;
}
const PitBimwinSwitchCheckBox: FC<PitBimwinSwitchCheckBoxProps> = ({
  value,
  onChange,
}) => {
  const handleClick = () => {
    onChange && onChange(!value);
  };
  return (
    <div
      className={`SwitchCheckBox pointer ${!value ? 'value-no' : ''}`}
      onClick={handleClick}
    >
      <div className="content"></div>
      <div className={`control ${value === false ? 'no' : ''}`}>
        <div className="big"></div>
        <div className="small"></div>
      </div>
      <div className="left-text" style={{ display: value ? '' : 'none' }}>
        Yes
      </div>
      <div className="right-text" style={{ display: !value ? '' : 'none' }}>
        No
      </div>
    </div>
  );
};
export default PitBimwinSwitchCheckBox;
